import { Component, EventEmitter, Input, Output, OnInit, ViewChild, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ApiService } from '../../services/api.service';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { MessageService } from 'primeng/api';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { AvatarModule } from 'primeng/avatar';
import { Subscription } from 'rxjs';
import { SidebarModule } from 'primeng/sidebar';
import { SearchService } from '../../services/search.service';
import { PermissionsService } from '../../services/permission.service';
import { SubMenuTabsComponent } from '../sub-menu-tabs/sub-menu-tabs.component';
import { MenuItem } from 'primeng/api';
import { UserEventHistoryService } from '../../services/user-event-history.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule, DialogModule, FormsModule, DropdownModule, OverlayPanelModule, AvatarModule, SidebarModule, SubMenuTabsComponent]
})

export class HeaderComponent implements OnInit, OnDestroy , AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  @Output() subMenuClick = new EventEmitter<string>();
  @Input() sidebarMode: 'narrow' | 'expanded' | 'hidden' = 'expanded';
  @Input() isHovering: boolean;
  @Input() showSubMenuTabs = false;
  @Input() activeMenuWithSubItems: MenuItem | null = null;
  @Input() activeMenu = '';
  @Input() subMenuItems: MenuItem[] = [];
  @Input() currentSubMenu = '';
  @Input() activeMenuIcon = '';
  @ViewChild('op') overlayPanel: OverlayPanel;

  currentTheme: 'aura-then' | 'noir' = 'noir';
  isMobile = false;
  showLogout: boolean = false;
  displayDialog: boolean = false;
  selectedRole: any;
  roles: any;
  first_name = sessionStorage.getItem('first_name')
  last_name = sessionStorage.getItem('last_name')
  login_name = sessionStorage.getItem('login_name')
  rank_name = sessionStorage.getItem('rank_name')
  role = sessionStorage.getItem('user_role_name')
  roleID = sessionStorage.getItem('user_role_id')
  userID = sessionStorage.getItem('user_id')
  unit_name = sessionStorage.getItem('unit_name')
  showNotification: boolean = false
  notifications: any
  groupedNotifications: GroupedNotification[] = [];
  private subscriptions = new Subscription();
  searchQuery: string = '';
  @ViewChild('roleBtn') roleBtn: ElementRef;
  @ViewChild('roleTooltip') roleTooltip: Tooltip;

  constructor(
    private themeService: ThemeService,
    private router: Router,
    private api: ApiService,
    private messageService: MessageService,
    private searchService: SearchService,
    private permissionService: PermissionsService,
    private userEventHistoryService: UserEventHistoryService
  ) {
    this.themeService.theme$.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnInit() {
    this.checkScreenSize();

    // Listen for window resize events
    window.addEventListener('resize', () => {
      this.checkScreenSize();
    });
    const role = sessionStorage.getItem('userRole');
    if (role) {
      this.selectedRole = this.roles.find(r => r.code === role);
      this.router.navigate(['/dashboard']);
    }
    window.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener('click', this.handleClickOutside, true);
    // this.groupByDate();
    // if (sessionStorage.getItem('access')) {
    //   this.notification()
    // }
     if (this.api.isLoggedIn()) {
    this.notification();
  }
  }
   ngAfterViewInit(): void {
    // Show tooltip only on first login
      setTimeout(() => {
        // this.roleTooltip.show();
      }, 1000);
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    window.removeEventListener('scroll', this.handleScroll, true);
    window.removeEventListener('click', this.handleClickOutside, true);
  }

  handleScroll = () => {
    if (this.overlayPanel) {
      this.overlayPanel.hide();
    }
  }

  handleClickOutside = (event: MouseEvent) => {
    const panel = document.querySelector('.p-overlaypanel');
    if (panel && !panel.contains(event.target as Node)) {
      this.overlayPanel?.hide();
    }
  }
  private checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
  }

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }

  onSubMenuClick(subMenuLabel: string): void {
    this.subMenuClick.emit(subMenuLabel);
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }
  showLogoutPopup() {
    this.showLogout = true;
  }
  logout() {
    let user_id = sessionStorage.getItem('user_id')
    console.log(">>>>>user_id:",user_id);
    this.userEventHistoryService.forceSyncNow().subscribe({
      next: () => this.completeLogout(user_id),
      error: () => this.completeLogout(user_id)
    });
  }

  private completeLogout(user_id: string | null): void {
    this.api.postAPI('/account/logout', { user_id }).subscribe((response) => {
      console.log('logout response', response);

      this.router.navigate(['/login']);
      sessionStorage.clear();
      localStorage.clear();
    });
  }
  ticketManagement() {

  }
  kmp() {

  }
 onSearch() {
    if (this.searchQuery.trim()) {
      this.searchService.search(this.searchQuery.trim());
      // this.searchQuery = ''
      this.router.navigate(['/search'], { 
        queryParams: { q: this.searchQuery.trim() ,  state: { clearSearch: true } } 
      });
    }
  }
  clearSearch() {
    this.searchQuery = '';
  }
  showDialog() {
    this.displayDialog = true;
    this.roleChange();
  }
  roleChange() {
    this.subscriptions.add(this.api.getAPI(`/access/get-user-roles/`).subscribe((res: any) => {
      this.roles = res
    })
    );
  }
  confirmRoleChange() {
    if (this.selectedRole) {
      sessionStorage.setItem('user_role_id', this.selectedRole.role_id);
      sessionStorage.setItem('user_role_name', this.selectedRole.role_name);
      this.role = sessionStorage.getItem('user_role_name')
      this.displayDialog = false;
      this.roleID = this.selectedRole.role_id
      // this.loadDataForRole(this.selectedRole.code);
      // window.location.reload()
      this.router.navigate(['/dashboard']);
      let activeSubmenuIndex = { menuIndex: 0 };
      localStorage.setItem('activeSubmenuIndex', JSON.stringify(activeSubmenuIndex));
      // localStorage.setItem('expandedMenuIndex', '0');
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `Role has now been changed to ${this.selectedRole.role_name}.`
      })
      this.notification();
      this.getPermissions();
    }
  }
  notification() {

    this.subscriptions.add(this.api.getAPI(`/notification/notification-users/?user_id=${this.userID}&role_id=${this.roleID}`)
      .subscribe((res: any) => {
        this.notifications = res.results.notifications;
        this.groupedNotifications = this.groupByDate(this.notifications);
      })
    );
  }
getPermissions(){
  let role_id = sessionStorage.getItem('user_role_id')
    this.api
              .getAPI(
                `/access/get-permissions/?role_id=${role_id}`
              )
              .subscribe((res: any) => {
                this.permissionService.setPermissions(res);
              });
}
  markAsRead(notification?: Notification) {

    if (notification) {
      notification.view = true;

      // Optional: Send update to backend
      this.subscriptions.add(this.api.postAPI('/notification/notification-seen/', {
        role_id: this.roleID
      }).subscribe({
        next: () => {
          this.notification(); // Call GET API to refresh the list
          //  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Notification removed' });
        },
        error: (err) => {
          console.error('Failed to close notification:', err);
        }
      })
      );
    }
    // Refresh the UI
    this.groupedNotifications = this.groupByDate(this.notifications);
  }

  closeNotification(notification: Notification) {
    notification['close'] = true;

    // Remove from local list
    this.notifications = this.notifications.filter(n => n.id !== notification.id);

    // Refresh the grouped UI
    this.groupedNotifications = this.groupByDate(this.notifications);

    // Optional: Call backend to persist
    this.subscriptions.add(this.api.postAPI('/notification/notification-closed/', {
      id: notification.id,
    }).subscribe({
      next: () => {
        this.notification(); // Call GET API to refresh the list
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Notification removed' });
      },
      error: (err) => {
        console.error('Failed to close notification:', err);
      }
    })
    );
  }

  hasUnreadNotifications(): boolean {
    return this.groupedNotifications.some(group =>
      group.notifications.some(notif => !notif.view)
    );
  }

  groupByDate(notifs: Notification[]): GroupedNotification[] {
    const groups: { [key: string]: Notification[] } = {};

    notifs.forEach(n => {
      const dateKey = new Date(n.created_on).toDateString();
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(n);
    });

    return Object.keys(groups).map(date => ({
      dateLabel: date,
      notifications: groups[date],
    }));
  }


  isSameDay(date1: Date, date2: Date) {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }
  disableBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  enableBodyScroll() {
    document.body.style.overflow = 'auto';
  }

  helpline() {

  }
  onViewNotification(notif: any): void {
      this.showNotification = false;
  // Mark as read (optional)
  if (!notif.view) {
    this.markAsRead(notif);
  }
  console.log(notif,'proposal_id notify')

  // Example: Navigate based on notif type
   if (notif.scheme_name == 'IDEX DISC') {
      this.router.navigate(['/idex-transaction'], {
        queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    } else if (notif.scheme_name == 'IDEX 4 Fauji') {
      this.router.navigate(['/idex-fauji-transaction'], {
      queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    } else if (notif.scheme_name == 'IDEX ADITI') {
      this.router.navigate(['/idex-aditi-transaction'], {
        queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    }
    else if (notif.scheme_name == 'IDEX OC') {
      this.router.navigate(['/idex-oc-transaction'], {
       queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    } else if (notif.scheme_name == 'Make I') {
      this.router.navigate(['/make-i-transaction'], {
       queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    } else if (notif.scheme_name == 'Make II') {
      this.router.navigate(['/make-ii-transaction'], {
       queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    } else if (notif.scheme_name == 'Make III') {
      this.router.navigate(['/make-ii-transaction'], {
       queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    } else if (notif.scheme_name == 'TDF') {
      this.router.navigate(['/tdf-transaction'], {
       queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    }
    else {
      this.router.navigate(['/transaction'], {
       queryParams: { id: notif.proposal, name: notif.proposal_name, scheme: notif.scheme_id, phase: notif.phase_id , step:notif.proposal_Step }
      });
    }
  }
  navigateToNotif(){
    this.router.navigate(['notification'])
  }
}

interface Notification {
  id: number;
  message: string;
  created_on: string;
  view: boolean;
  close?: boolean; // Optional close flag used in your code
  [key: string]: any;
}

interface GroupedNotification {
  dateLabel: string;
  notifications: Notification[];
}
